import React from "react";
import { UserFeedsType } from "../../types";

type UserFeedModalContentProps = {
  content?: string;
  userFeed: UserFeedsType | undefined;
  feedImages: string[] | undefined;
  feedVideo?: string[];
};
const UserFeedModalContent: React.FC<UserFeedModalContentProps> = ({
  content,
  userFeed,
  feedImages,
  feedVideo,
}) => {
  const maxLength = 400;
  const [isExpanded, setIsExpanded] = React.useState(false);
  const backgroundColor = userFeed?.feedBackground || "";

  return (
    <>
      {feedVideo?.length || feedImages?.length ? (
        <div className="w-full block lg:md:whitespace-pre-line text-black whitespace-pre-line p-1 px-4 break-words text-justify font-SegoeUI mb-2 gap-2 text-sm font-light">
          {content && content.length <= maxLength
            ? content
            : isExpanded
            ? content
            : content?.slice(0, maxLength)}
          {content && content.length > maxLength && (
            <span
              className="cursor-pointer font-extralight text-[10px] pl-2 font-SegoeUI text-greyText"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {!isExpanded ? " ... See more" : " ... See less"}
            </span>
          )}
        </div>
      ) : (
        <div
          className={`w-full block whitespace-pre-line break-words text-start font-SegoeUI gap-2 px-4 mb-4
            ${
              content && content.length > 100
                ? `${
                    backgroundColor.length === 0
                      ? `p-1 text-base font-normal h-auto mb-7`
                      : "p-5 text-base font-normal h-auto mt-4 mb-7"
                  }`
                : `  ${
                    backgroundColor.length === 0
                      ? "py-16 h-full font-medium lg:md:px-[52px] px-11 lg:text-2xl text-lg mb-7"
                      : "py-[100px] h-full font-medium lg:md:px-[52px] px-11 lg:text-2xl text-lg mt-2 mb-7"
                  }  `
            }
        `}
          style={{ background: backgroundColor }}
          key={content}
        >
          {content && content.length <= maxLength
            ? content
            : isExpanded
            ? content
            : content?.slice(0, maxLength)}
          {content && content.length > maxLength && (
            <span
              className="cursor-pointer font-extralight text-[10px] pl-2 font-SegoeUI text-greyText"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {!isExpanded ? "... See more" : "... See less"}
            </span>
          )}
        </div>
      )}
    </>
  );
};

export default UserFeedModalContent;
